import { CurrentUser } from "../providers/current-user";

export interface VoterInterface {
    /**
     * Returns the vote for the given parameters.
     *
     * This method must return one of the following constants:
     * ACCESS_GRANTED, ACCESS_DENIED, or ACCESS_ABSTAIN.
     *
     * @param {CurrentUser} currentUser     The authenticated user
     * @param {array}       attributes An array of attributes associated with the method being invoked
     * @param {Object}      subject    The subject to secure
     *
     * @return int either ACCESS_GRANTED, ACCESS_ABSTAIN, or ACCESS_DENIED
     */
    vote(currentUser: CurrentUser, attributes: any, subject: any): number;
}

export abstract class VoterInterfaceConstants {
    public static readonly ACCESS_GRANTED: number = 1;
    public static readonly ACCESS_ABSTAIN: number = 0;
    public static readonly ACCESS_DENIED: number = -1;
}
